import { render, staticRenderFns } from "./ConsumablesCategorical.vue?vue&type=template&id=8a440a9e&scoped=true&"
import script from "./ConsumablesCategorical.vue?vue&type=script&lang=js&"
export * from "./ConsumablesCategorical.vue?vue&type=script&lang=js&"
import style0 from "./ConsumablesCategorical.vue?vue&type=style&index=0&id=8a440a9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a440a9e",
  null
  
)

export default component.exports